import TypeCheck from "../../utils/Typecheck";

export interface Position {
    x: number
    y: number
}

export const isPosition = (content: unknown): content is Position => {
    return TypeCheck.isObject(content)
        && TypeCheck.hasAll(content, ['x', 'y'])
        && TypeCheck.isNumber(content.x)
        && TypeCheck.isNumber(content.y);
}
